var map = {
	"./8514sys.fon.txt": "./src/fonts/materials-fonts/8514sys.fon.txt",
	"./ARIALN.TTF.txt": "./src/fonts/materials-fonts/ARIALN.TTF.txt",
	"./ARIALNB.TTF.txt": "./src/fonts/materials-fonts/ARIALNB.TTF.txt",
	"./ARIALNBI.TTF.txt": "./src/fonts/materials-fonts/ARIALNBI.TTF.txt",
	"./ARIALNI.TTF.txt": "./src/fonts/materials-fonts/ARIALNI.TTF.txt",
	"./LCALLIG.TTF.txt": "./src/fonts/materials-fonts/LCALLIG.TTF.txt",
	"./LHANDW.TTF.txt": "./src/fonts/materials-fonts/LHANDW.TTF.txt",
	"./MAGNETOB.TTF.txt": "./src/fonts/materials-fonts/MAGNETOB.TTF.txt",
	"./MOD20.TTF.txt": "./src/fonts/materials-fonts/MOD20.TTF.txt",
	"./MTCORSVA.TTF.txt": "./src/fonts/materials-fonts/MTCORSVA.TTF.txt",
	"./Monoton-Regular.ttf.txt": "./src/fonts/materials-fonts/Monoton-Regular.ttf.txt",
	"./REFSAN.TTF.txt": "./src/fonts/materials-fonts/REFSAN.TTF.txt",
	"./SCRIPTBL.TTF.txt": "./src/fonts/materials-fonts/SCRIPTBL.TTF.txt",
	"./WarnerBrosSans-Bold.ttf.txt": "./src/fonts/materials-fonts/WarnerBrosSans-Bold.ttf.txt",
	"./WarnerBrosSans-Heavy.ttf.txt": "./src/fonts/materials-fonts/WarnerBrosSans-Heavy.ttf.txt",
	"./WarnerBrosSans-Regular.ttf.txt": "./src/fonts/materials-fonts/WarnerBrosSans-Regular.ttf.txt",
	"./WarnerBrosSansCond-Bold.ttf.txt": "./src/fonts/materials-fonts/WarnerBrosSansCond-Bold.ttf.txt",
	"./arial.ttf.txt": "./src/fonts/materials-fonts/arial.ttf.txt",
	"./arialbd.ttf.txt": "./src/fonts/materials-fonts/arialbd.ttf.txt",
	"./arialbi.ttf.txt": "./src/fonts/materials-fonts/arialbi.ttf.txt",
	"./ariali.ttf.txt": "./src/fonts/materials-fonts/ariali.ttf.txt",
	"./ariblk.ttf.txt": "./src/fonts/materials-fonts/ariblk.ttf.txt",
	"./calibri.ttf.txt": "./src/fonts/materials-fonts/calibri.ttf.txt",
	"./calibrib.ttf.txt": "./src/fonts/materials-fonts/calibrib.ttf.txt",
	"./calibrii.ttf.txt": "./src/fonts/materials-fonts/calibrii.ttf.txt",
	"./calibril.ttf.txt": "./src/fonts/materials-fonts/calibril.ttf.txt",
	"./calibrili.ttf.txt": "./src/fonts/materials-fonts/calibrili.ttf.txt",
	"./calibriz.ttf.txt": "./src/fonts/materials-fonts/calibriz.ttf.txt",
	"./consola.ttf.txt": "./src/fonts/materials-fonts/consola.ttf.txt",
	"./consolab.ttf.txt": "./src/fonts/materials-fonts/consolab.ttf.txt",
	"./consolai.ttf.txt": "./src/fonts/materials-fonts/consolai.ttf.txt",
	"./consolaz.ttf.txt": "./src/fonts/materials-fonts/consolaz.ttf.txt",
	"./cour.ttf.txt": "./src/fonts/materials-fonts/cour.ttf.txt",
	"./courbd.ttf.txt": "./src/fonts/materials-fonts/courbd.ttf.txt",
	"./courbi.ttf.txt": "./src/fonts/materials-fonts/courbi.ttf.txt",
	"./coure.fon.txt": "./src/fonts/materials-fonts/coure.fon.txt",
	"./couri.ttf.txt": "./src/fonts/materials-fonts/couri.ttf.txt",
	"./dosapp.fon.txt": "./src/fonts/materials-fonts/dosapp.fon.txt",
	"./l_10646.ttf.txt": "./src/fonts/materials-fonts/l_10646.ttf.txt",
	"./lucon.ttf.txt": "./src/fonts/materials-fonts/lucon.ttf.txt",
	"./micross.ttf.txt": "./src/fonts/materials-fonts/micross.ttf.txt",
	"./modern.fon.txt": "./src/fonts/materials-fonts/modern.fon.txt",
	"./roman.fon.txt": "./src/fonts/materials-fonts/roman.fon.txt",
	"./script.fon.txt": "./src/fonts/materials-fonts/script.fon.txt",
	"./segoepr.ttf.txt": "./src/fonts/materials-fonts/segoepr.ttf.txt",
	"./segoeprb.ttf.txt": "./src/fonts/materials-fonts/segoeprb.ttf.txt",
	"./segoesc.ttf.txt": "./src/fonts/materials-fonts/segoesc.ttf.txt",
	"./segoescb.ttf.txt": "./src/fonts/materials-fonts/segoescb.ttf.txt",
	"./segoeui.ttf.txt": "./src/fonts/materials-fonts/segoeui.ttf.txt",
	"./segoeuib.ttf.txt": "./src/fonts/materials-fonts/segoeuib.ttf.txt",
	"./segoeuii.ttf.txt": "./src/fonts/materials-fonts/segoeuii.ttf.txt",
	"./segoeuil.ttf.txt": "./src/fonts/materials-fonts/segoeuil.ttf.txt",
	"./segoeuisl.ttf.txt": "./src/fonts/materials-fonts/segoeuisl.ttf.txt",
	"./segoeuiz.ttf.txt": "./src/fonts/materials-fonts/segoeuiz.ttf.txt",
	"./seguibl.ttf.txt": "./src/fonts/materials-fonts/seguibl.ttf.txt",
	"./seguibli.ttf.txt": "./src/fonts/materials-fonts/seguibli.ttf.txt",
	"./seguihis.ttf.txt": "./src/fonts/materials-fonts/seguihis.ttf.txt",
	"./seguili.ttf.txt": "./src/fonts/materials-fonts/seguili.ttf.txt",
	"./seguisb.ttf.txt": "./src/fonts/materials-fonts/seguisb.ttf.txt",
	"./seguisbi.ttf.txt": "./src/fonts/materials-fonts/seguisbi.ttf.txt",
	"./seguisli.ttf.txt": "./src/fonts/materials-fonts/seguisli.ttf.txt",
	"./seguisym.ttf.txt": "./src/fonts/materials-fonts/seguisym.ttf.txt",
	"./sserife.fon.txt": "./src/fonts/materials-fonts/sserife.fon.txt",
	"./tahoma.ttf.txt": "./src/fonts/materials-fonts/tahoma.ttf.txt",
	"./tahomabd.ttf.txt": "./src/fonts/materials-fonts/tahomabd.ttf.txt",
	"./times.ttf.txt": "./src/fonts/materials-fonts/times.ttf.txt",
	"./timesbd.ttf.txt": "./src/fonts/materials-fonts/timesbd.ttf.txt",
	"./timesbi.ttf.txt": "./src/fonts/materials-fonts/timesbi.ttf.txt",
	"./timesi.ttf.txt": "./src/fonts/materials-fonts/timesi.ttf.txt",
	"./verdana.ttf.txt": "./src/fonts/materials-fonts/verdana.ttf.txt",
	"./verdanab.ttf.txt": "./src/fonts/materials-fonts/verdanab.ttf.txt",
	"./verdanai.ttf.txt": "./src/fonts/materials-fonts/verdanai.ttf.txt",
	"./verdanaz.ttf.txt": "./src/fonts/materials-fonts/verdanaz.ttf.txt",
	"./vgaoem.fon.txt": "./src/fonts/materials-fonts/vgaoem.fon.txt"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/fonts/materials-fonts sync \\.(txt)";